import counters from '@/api/counters'

export default {
    namespaced: true,
    state: {
        items: [],
        selectedItem: null,
        editedId: -1,
        editedItem: {
            name: ''
        },
        defaultItem: {
            name: ''
        }
    },
    getters: {},
    actions: {
        fetchAll ({ commit }, { devices, application, startDate, endDate }) {
            return new Promise((resolve, reject) => {
                let data = {
                    devices,
                    ...(application && { application_id: application }),
                    ...(startDate && { start_date: startDate }),
                    ...(endDate && { end_date: endDate })
                }

                counters.index(data).then(response => {
                    commit('setItems', response.data)
                    resolve(response.data)
                }).catch(error => reject(error));
            })
        },
        resetEditedItem ({ commit, state }) {
            commit('setEditedId', -1)
            commit('setEditedItem', Object.assign({}, state.defaultItem))
        },
        saveEditedItem ({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                counters.store(state.editedItem).then(response => {
                    dispatch('fetchAll')
                    dispatch('resetEditedItem')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        updateEditedItem ({ dispatch, state }) {
            return new Promise((resolve, reject) => {
                counters.update(state.editedId, state.editedItem).then(response => {
                    dispatch('fetchAll')
                    dispatch('resetEditedItem')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        deleteItem ({ dispatch }, id) {
            return new Promise((resolve, reject) => {
                counters.delete(id).then(response => {
                    dispatch('fetchAll')
                    resolve(response)
                }).catch(error => reject(error))
            })
        },
        reset ({ commit, dispatch }) {
            commit('setItems', [])
            dispatch('resetEditedItem')
        }
    },
    mutations: {
        setItems (state, items) {
            state.items = items
        },
        setEditedItem (state, item) {
            const editedItem = {
                name: item.name
            }
            state.editedItem = editedItem
        },
        setEditedId (state, id) {
            state.editedId = id
        }
    }
}